// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"M--z"};